module.exports = __webpack_public_path__ + "media/markers/marker-transparent-gray-9103adc5.svg";